// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"w7","subText":"w8"};